import React, { useRef } from "react";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { PROPERTY_DETAIL_URL } from "../../global/API";
import { Icon } from "@iconify/react/dist/iconify.js";
import "./propertyDetail.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import Cookies from "js-cookie";
import AddLead from "../addLead/addlead";

const PropertyDetail = () => {
  const { id } = useParams();

  const [propertyDetailData, setPropertyDetailData] = useState({});

  const [viewContent, setViewContent] = useState(false);

  const [propertyInfo, setPropertyInfo] = useState("propertyInfo");

  const swiperRef = useRef(null);

  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const [selectedListings, setSelectedListings] = useState([]);

  const handleSlideClick = (index) => {
    if (swiperRef.current) {
      swiperRef.current.slideTo(index);
      setCurrentImageIndex(index);
    }
  };

  const getPropertyDetail = async () => {
    const jwtToken = Cookies.get("jwtToken");
    const options = {
      method: "GET",
      headers: { Authorization: `Bearer ${jwtToken}` },
    };
    const URL = PROPERTY_DETAIL_URL + id;

    const response = await fetch(URL, options);
    try {
      if (response.ok) {
        const data = await response.json();
        setPropertyDetailData(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getPropertyDetail();
  }, []);

  const renderPropertyDetailView = () => {
    const { property, advanced, images } = propertyDetailData.data;
    const { address, cityName, state, totalBaths, bedrooms, listingPrice, sqFt, remarksConcat, propType, propStatus, fullBaths, halfBaths, listingID, propSubType, latitude, longitude, full_address } =
      property;

    const advanceOptions = advanced.map((obj) => {
      const key = Object.keys(obj)[0];
      const value = obj[key];

      const formattedKey = key.replace(/([A-Z])/g, " $1").replace(/^./, (str) => str.toUpperCase());

      return {
        key: formattedKey,
        value: String(value),
      };
    });

    return (
      <div className="page-content property-detail">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="page-title-box">
                <ul className="breadcrumb breadcrumb-big mb-0">
                  <li className="breadcrumb-item">
                    <Link to="/properties" className="breadcrumb-link">
                      Property Listings
                    </Link>
                  </li>
                  <li className="breadcrumb-item active">
                    <Icon icon="solar:map-point-wave-bold-duotone" className="fs-18 text-primary"></Icon>
                    {full_address}
                  </li>
                </ul>
                <div className="price-tag">
                  <Icon icon="solar:wallet-money-bold-duotone" className="text-success avatar-title"></Icon>
                  {listingPrice}
                </div>
              </div>
            </div>
          </div>
          <div>
            {propertyInfo === "propertyTour" && (
              <button type="button" className="btn add-btn add-btn-new" data-bs-toggle="modal" data-bs-target="#addLead">
                Add Lead
              </button>
            )}
            <ul className="property-info-list">
              <li>
                <button
                  type="button"
                  onClick={() => {
                    setPropertyInfo("propertyInfo");
                  }}
                  className={propertyInfo === "propertyInfo" ? "property-button active" : "property-button"}
                >
                  Property Information
                </button>
              </li>
              <li>
                <button
                  type="button"
                  onClick={() => {
                    setPropertyInfo("propertyTour");
                  }}
                  className={propertyInfo === "propertyTour" ? "property-button active" : "property-button"}
                >
                  Leads
                </button>
              </li>
              {/* <li>
                <button
                  type="button"
                  onClick={() => {
                    setPropertyInfo("propertyAgents");
                  }}
                  className={
                    propertyInfo === "propertyAgents"
                      ? "property-button active"
                      : "property-button"
                  }
                >
                  Contact Agents
                </button>
              </li> */}
            </ul>
          </div>
          {propertyInfo === "propertyInfo" && (
            <div className="row">
              <div className="col-xl-9 col-lg-8">
                <div className="card">
                  <div className="card-body">
                    <div className="image-slider">
                      <img src={images[currentImageIndex].full} alt="" className="image-slider-large rounded" />
                      <Swiper
                        className="image-slider-nav"
                        modules={[Navigation]}
                        slidesPerView={3}
                        spaceBetween={10}
                        allowTouchMove={false}
                        navigation
                        direction="vertical"
                        style={{ height: "500px" }}
                        onSwiper={(swiper) => (swiperRef.current = swiper)}
                      >
                        {images.map((img, index) => (
                          <SwiperSlide key={index} onClick={() => handleSlideClick(index)}>
                            <img src={img.full} alt="" />
                          </SwiperSlide>
                        ))}
                        <button
                          className="swiper-button-prev"
                          onClick={() => {
                            swiperRef.current?.slidePrev();
                            setCurrentImageIndex(swiperRef.current.activeIndex);
                          }}
                        ></button>
                        <button
                          className="swiper-button-next"
                          onClick={() => {
                            swiperRef.current?.slideNext();
                            setCurrentImageIndex(swiperRef.current.activeIndex);
                          }}
                        ></button>
                      </Swiper>
                    </div>

                    <div className="row mt-4">
                      <div className="col-12">
                        <div className="bg-light-subtle p-2 rounded border border-dashed">
                          <div className="row align-items-center text-center g-2">
                            <div className="col-xl-2 col-lg-3 col-md-6 col-6 border-end">
                              <p className="text-muted mb-0 fs-15 fw-medium d-flex align-items-center justify-content-center gap-1">
                                <Icon icon="solar:bed-broken" className="fs-18 text-primary"></Icon>
                                {bedrooms} Bedroom
                              </p>
                            </div>
                            <div className="col-xl-2 col-lg-3 col-md-6 col-6 border-end">
                              <p className="text-muted mb-0 fs-15 fw-medium d-flex align-items-center justify-content-center gap-1">
                                <Icon icon="solar:bath-broken" className="fs-18 text-primary"></Icon>
                                {totalBaths} Bathrooms
                              </p>
                            </div>
                            <div className="col-xl-2 col-lg-3 col-md-6 col-6 border-end">
                              <p className="text-muted mb-0 fs-15 fw-medium d-flex align-items-center justify-content-center gap-1">
                                <Icon icon="solar:scale-broken" className="fs-18 text-primary"></Icon>
                                {sqFt} sqft
                              </p>
                            </div>
                            <div className="col-xl-2 col-lg-3 col-md-6 col-6">
                              <p className="text-muted mb-0 fs-15 fw-medium d-flex align-items-center justify-content-center gap-1">
                                <Icon icon="solar:home-broken" className="fs-18 text-primary"></Icon>
                                {propType}
                              </p>
                            </div>
                          </div>
                        </div>

                        <h4 className="text-dark fw-medium mt-4">Property Description</h4>
                        <p className="mt-2">{remarksConcat}</p>

                        <h4 className="text-dark fw-medium mt-4 bordered-heading">Property Details</h4>
                        <ul className="property-list">
                          <li>
                            <strong>Property Type:</strong>
                            <span>{propType}</span>
                          </li>
                          <li>
                            <strong>Sub Type:</strong>
                            <span>{propSubType}</span>
                          </li>
                          <li>
                            <strong>Listing Status:</strong>
                            <span>{propStatus}</span>
                          </li>
                          <li>
                            <strong>Square Footage:</strong>
                            <span>{sqFt} sqft</span>
                          </li>
                          <li>
                            <strong>Listing ID:</strong>
                            <span>{listingID}</span>
                          </li>
                          <li>
                            <strong>Bedrooms:</strong>
                            <span>{bedrooms}</span>
                          </li>
                          <li>
                            <strong>Full Baths:</strong>
                            <span>{fullBaths}</span>
                          </li>
                          <li>
                            <strong>Half Baths:</strong>
                            <span>{halfBaths}</span>
                          </li>
                          <li>
                            <strong>Abv Grd Liv Area:</strong>
                            <span>{sqFt}</span>
                          </li>
                        </ul>
                        {viewContent && (
                          <div className="property-collapse">
                            <h4 className="text-dark fw-medium mt-4 bordered-heading">Property Features</h4>
                            <ul className="property-list">
                              {advanceOptions.map((item, index) => {
                                if (item.key !== "Property Disclaimer" && item.value !== "null") {
                                  return (
                                    <li key={index}>
                                      <strong>{item.key}:</strong>
                                      <span>{item.value}</span>
                                    </li>
                                  );
                                }
                              })}
                            </ul>
                            <div className="gmap_canvas mt-4">
                              <iframe className="gmap_iframe rounded" loading="lazy" allowFullScreen src={`https://www.google.com/maps?q=${latitude},${longitude}&z=12&output=embed`}></iframe>
                            </div>
                          </div>
                        )}
                        <div className="d-flex align-items-center justify-content-between mt-4">
                          <button
                            type="button"
                            className="link-primary fw-medium"
                            onClick={() => {
                              setViewContent(!viewContent);
                            }}
                          >
                            View {viewContent ? "Less" : "More"}
                          </button>
                          {/* <div>
                      <p className="mb-0 d-flex align-items-center gap-1">
                        <Icon
                          icon="solar:calendar-date-broken"
                          className="fs-18 text-primary"
                        ></Icon>
                        10 May 2024
                      </p>
                    </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-lg-4">
                <div className="card agent-card">
                  <div className="card-header bg-light-subtle">
                    <h4 className="card-title">Property Agent Details</h4>
                  </div>
                  <div className="card-body">
                    <div className="text-center">
                      <div className="avatar-xl rounded-circle border border-2 border-light mx-auto">
                        <img src="/assets/images/agent-photo.jpg" alt="" />
                      </div>

                      <div className="mt-2">
                        <a href="#!" className="fw-medium text-dark fs-16">
                          Sal Madrigal
                        </a>
                        <p className="mb-3">(Realtor)</p>
                        <p className="mb-1">
                          Cell Phone: <a href="+17073541950">(707) 354-1950</a>
                        </p>
                        <p className="mb-1">
                          Office Phone: <a href="+17074673692">(707) 467-3692</a>
                        </p>
                        <p className="mb-4">Known Languages: English, Spanish</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {propertyInfo === "propertyTour" && (
            <div className="card">
              {/* <div className="card-header d-flex justify-content-between align-items-center border-bottom">
                <div>
                  <h4 className="card-title">Tour List</h4>
                </div>
              </div> */}
              <div className="card-body p-0">
                <div className="table-responsive">
                  <table className="table align-middle text-nowrap table-hover table-centered mb-0 property-table">
                    <thead className="bg-light-subtle">
                      <tr>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Contact</th>
                        <th>Date & Time</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <div className="d-flex align-items-center gap-2">
                            <a href="#!" className="text-dark fw-medium fs-15">
                              Michael A. Miner
                            </a>
                          </div>
                        </td>
                        <td>michaelminer@dayrep.com</td>
                        <td>+787 608-360-0464</td>
                        <td>21 May 2018, 8AM - 12PM</td>
                        <td>
                          <div className="d-flex gap-2">
                            {/* <a href="#!" className="btn btn-light btn-sm">
                              <Icon
                                icon="solar:eye-broken"
                                className="align-middle fs-18"
                              ></Icon>
                            </a> */}
                            <a href="#!" className="btn btn-soft-primary btn-sm">
                              <Icon icon="solar:pen-2-broken" className="align-middle fs-18"></Icon>
                            </a>
                            <a href="#!" className="btn btn-soft-danger btn-sm">
                              <Icon icon="solar:trash-bin-minimalistic-2-broken" className="align-middle fs-18"></Icon>
                            </a>
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <div className="d-flex align-items-center gap-2">
                            <a href="#!" className="text-dark fw-medium fs-15">
                              Theresa T. Brose
                            </a>
                          </div>
                        </td>
                        <td>theresbrosea@dayrep.com</td>
                        <td>+787 314-832-1736</td>
                        <td>24 Apr 2022, 8AM - 12PM</td>
                        <td>
                          <div className="d-flex gap-2">
                            {/* <a href="#!" className="btn btn-light btn-sm">
                              <Icon
                                icon="solar:eye-broken"
                                className="align-middle fs-18"
                              ></Icon>
                            </a> */}
                            <a href="#!" className="btn btn-soft-primary btn-sm">
                              <Icon icon="solar:pen-2-broken" className="align-middle fs-18"></Icon>
                            </a>
                            <a href="#!" className="btn btn-soft-danger btn-sm">
                              <Icon icon="solar:trash-bin-minimalistic-2-broken" className="align-middle fs-18"></Icon>
                            </a>
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <div className="d-flex align-items-center gap-2">
                            <a href="#!" className="text-dark fw-medium fs-15">
                              Walter L. Calab
                            </a>
                          </div>
                        </td>
                        <td>walterlcalabre@jourrapide.com</td>
                        <td>+787 516-557-2847</td>
                        <td>04 Jan 2015, 8AM - 12PM</td>
                        <td>
                          <div className="d-flex gap-2">
                            {/* <a href="#!" className="btn btn-light btn-sm">
                              <Icon
                                icon="solar:eye-broken"
                                className="align-middle fs-18"
                              ></Icon>
                            </a> */}
                            <a href="#!" className="btn btn-soft-primary btn-sm">
                              <Icon icon="solar:pen-2-broken" className="align-middle fs-18"></Icon>
                            </a>
                            <a href="#!" className="btn btn-soft-danger btn-sm">
                              <Icon icon="solar:trash-bin-minimalistic-2-broken" className="align-middle fs-18"></Icon>
                            </a>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div className="d-flex align-items-center gap-2">
                            <a href="#!" className="text-dark fw-medium fs-15">
                              Olive Mize
                            </a>
                          </div>
                        </td>
                        <td>olivehmize@rhyta.com</td>
                        <td>+787 858-947-3422</td>
                        <td>01 Dec 2020, 8AM - 12PM</td>
                        <td>
                          <div className="d-flex gap-2">
                            {/* <a href="#!" className="btn btn-light btn-sm">
                              <Icon
                                icon="solar:eye-broken"
                                className="align-middle fs-18"
                              ></Icon>
                            </a> */}
                            <a href="#!" className="btn btn-soft-primary btn-sm">
                              <Icon icon="solar:pen-2-broken" className="align-middle fs-18"></Icon>
                            </a>
                            <a href="#!" className="btn btn-soft-danger btn-sm">
                              <Icon icon="solar:trash-bin-minimalistic-2-broken" className="align-middle fs-18"></Icon>
                            </a>
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <div className="d-flex align-items-center gap-2">
                            <a href="#!" className="text-dark fw-medium fs-15">
                              Christa Sardina
                            </a>
                          </div>
                        </td>
                        <td>christasardina@dayrep.com</td>
                        <td>+787 573-758-6605</td>
                        <td>23 May 2019, 8AM - 12PM</td>
                        <td>
                          <div className="d-flex gap-2">
                            {/* <a href="#!" className="btn btn-light btn-sm">
                              <Icon
                                icon="solar:eye-broken"
                                className="align-middle fs-18"
                              ></Icon>
                            </a> */}
                            <a href="#!" className="btn btn-soft-primary btn-sm">
                              <Icon icon="solar:pen-2-broken" className="align-middle fs-18"></Icon>
                            </a>
                            <a href="#!" className="btn btn-soft-danger btn-sm">
                              <Icon icon="solar:trash-bin-minimalistic-2-broken" className="align-middle fs-18"></Icon>
                            </a>
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <div className="d-flex align-items-center gap-2">
                            <a href="#!" className="text-dark fw-medium fs-15">
                              Darren Rivera
                            </a>
                          </div>
                        </td>
                        <td>darrenwrivera@dayrep.com</td>
                        <td>+787 580-969-0491</td>
                        <td>06 Sep 2015, 8AM - 12PM</td>
                        <td>
                          <div className="d-flex gap-2">
                            {/* <a href="#!" className="btn btn-light btn-sm">
                              <Icon
                                icon="solar:eye-broken"
                                className="align-middle fs-18"
                              ></Icon>
                            </a> */}
                            <a href="#!" className="btn btn-soft-primary btn-sm">
                              <Icon icon="solar:pen-2-broken" className="align-middle fs-18"></Icon>
                            </a>
                            <a href="#!" className="btn btn-soft-danger btn-sm">
                              <Icon icon="solar:trash-bin-minimalistic-2-broken" className="align-middle fs-18"></Icon>
                            </a>
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <div className="d-flex align-items-center gap-2">
                            <a href="#!" className="text-dark fw-medium fs-15">
                              Robert V. Leavitt
                            </a>
                          </div>
                        </td>
                        <td>robertvleavitt@dayrep.com</td>
                        <td>+787 361-318-4753</td>
                        <td>05 Jun 2021, 8AM - 12PM</td>
                        <td>
                          <div className="d-flex gap-2">
                            {/* <a href="#!" className="btn btn-light btn-sm">
                              <Icon
                                icon="solar:eye-broken"
                                className="align-middle fs-18"
                              ></Icon>
                            </a> */}
                            <a href="#!" className="btn btn-soft-primary btn-sm">
                              <Icon icon="solar:pen-2-broken" className="align-middle fs-18"></Icon>
                            </a>
                            <a href="#!" className="btn btn-soft-danger btn-sm">
                              <Icon icon="solar:trash-bin-minimalistic-2-broken" className="align-middle fs-18"></Icon>
                            </a>
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <div className="d-flex align-items-center gap-2">
                            <a href="#!" className="text-dark fw-medium fs-15">
                              Lydia Anderson
                            </a>
                          </div>
                        </td>
                        <td>lydiajanderson@dayrep.com</td>
                        <td>+787 602-851-1066</td>
                        <td>28 May 2017, 8AM - 12PM</td>
                        <td>
                          <div className="d-flex gap-2">
                            {/* <a href="#!" className="btn btn-light btn-sm">
                              <Icon
                                icon="solar:eye-broken"
                                className="align-middle fs-18"
                              ></Icon>
                            </a> */}
                            <a href="#!" className="btn btn-soft-primary btn-sm">
                              <Icon icon="solar:pen-2-broken" className="align-middle fs-18"></Icon>
                            </a>
                            <a href="#!" className="btn btn-soft-danger btn-sm">
                              <Icon icon="solar:trash-bin-minimalistic-2-broken" className="align-middle fs-18"></Icon>
                            </a>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="card-footer">
                <nav aria-label="Page navigation example"></nav>
              </div>
            </div>
          )}
        </div>
        <AddLead selectedListings={selectedListings} />
      </div>
    );
  };
  return propertyDetailData.status !== undefined ? renderPropertyDetailView() : <span>Loading</span>;
};

export default PropertyDetail;
